import React from 'react';

export const themes = {
  dark: {
    colors: {
      primary: '#FFFFFF',
      secoundary: '#000000',
    },
    imageIconSmall: { fontSize: 30, color: '#000000' },
    imageIconMedium: { fontSize: 60, color: '#000000' },
    imageIconBig: { fontSize: 80, color: '#000000' },
  },
  light: {
    colors: {
      primary: '#000000',
      secoundary: '#FFFFFF',
    },
    imageIconSmall: { fontSize: 30, color: '#FFFFFF' },
    imageIconMedium: { fontSize: 60, color: '#FFFFFF' },
    imageIconBig: { fontSize: 80, color: '#FFFFFF' },
  },
  playon: {
    colors: {
      primary: '#14B395',
      secoundary: '#FFFFFF',
    },
    imageIconSmall: { fontSize: 30, color: '#FFFFFF' },
    imageIconMedium: { fontSize: 60, color: '#FFFFFF' },
    imageIconBig: { fontSize: 80, color: '#FFFFFF' },
  },
};

const ThemeContext = React.createContext(themes.playon);

export default ThemeContext;
